import { globalConst } from 'src/app/shared/helpers/constants';
import { Pipe, PipeTransform } from '@angular/core';
import { NgForm } from '@angular/forms';

@Pipe({
  name: 'requestStatus'
})
export class RequestStatusPipe implements PipeTransform {

  transform(situation: string): string {
    switch (situation) {
      case globalConst.defaults.situation.waiting.id:
        return globalConst.defaults.situation.waiting.text;
      case globalConst.defaults.situation.sended.id:
        return globalConst.defaults.situation.sended.text;
      case globalConst.defaults.situation.returned.id:
        return globalConst.defaults.situation.returned.text;
      case globalConst.defaults.situation.canceled.id:
        return globalConst.defaults.situation.canceled.text;
      default:
        return '';
    }
  }

}
